<template>
    <div>
        <navbar/>
        <div class="container mt-5 mb-5">
            <div class="policy-container">
                <h1 class="text-center">Privacy Policy</h1>
                <p class="text-center text-muted">Effective Date: August 2, 2025</p>

                <p>This Privacy Policy describes how <strong>“Just Bookmark It!”</strong> ("we", "us", or "our") collects, uses, and shares information when you use our iOS app. We are committed to protecting your privacy and complying with applicable data protection laws, including the <strong>General Data Protection Regulation (GDPR)</strong> and the <strong>California Consumer Privacy Act (CCPA)</strong>.</p>

                <h2>1. Information We Collect</h2>

                <h5>Email Address</h5>
                <ul>
                    <li>Collected manually during account signup</li>
                    <li>Used for authentication and communication (e.g., account emails, support)</li>
                    <li>Stored securely in our GCP database</li>
                    <li>Not used for tracking or advertising</li>
                    <li>Not linked to a legal identity</li>
                </ul>

                <h5>Usage Data</h5>
                <ul>
                    <li>Collected via custom backend logging</li>
                    <li>Used to improve app functionality and detect bugs</li>
                    <li>Stored securely on GCP infrastructure</li>
                    <li>Not linked to identity</li>
                    <li>Not used for tracking or advertising</li>
                </ul>

                <h5>Crash Logs and Diagnostics</h5>
                <ul>
                    <li>Collected through Xcode crash reporting tools</li>
                    <li>Used solely to fix bugs and improve stability</li>
                    <li>Not linked to identity</li>
                    <li>Not used for tracking or advertising</li>
                </ul>

                <h2>2. Data Storage and Security</h2>
                <p>All data is stored securely on our database hosted via <strong>Google Cloud Platform (GCP)</strong>. We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.</p>

                <h2>3. Account and Authentication</h2>
                <p>Account creation via <strong>email and password</strong> is required to access most features. Some features are available in guest mode without registration.</p>

                <h2>4. Data Retention and Deletion</h2>
                <p>We retain your personal data only as long as necessary. You may request deletion of your data by emailing us at: <a href="mailto:support@justbookmark.it">support@justbookmark.it</a></p>

                <h2>5. Children's Privacy</h2>
                <p>Our app is <strong>not intended for children under the age of 13</strong> (or under 16 in certain regions). We do not knowingly collect personal data from children.</p>

                <h2>6. Your Rights</h2>
                <p>Depending on your location, you may have the right to access, correct, delete, or object to the processing of your personal data. Contact us to exercise these rights.</p>

                <h2>7. Legal Basis for Processing (GDPR)</h2>
                <p>We process your data based on:</p>
                <ul>
                    <li>Your consent</li>
                    <li>Our legitimate interest in operating and improving the app</li>
                    <li>Compliance with legal obligations</li>
                </ul>

                <h2>8. California Privacy Rights (CCPA)</h2>
                <p>We do not sell your personal data. California residents may request information or deletion of their data by contacting us at <a href="mailto:support@justbookmark.it">support@justbookmark.it</a>.</p>

                <h2>9. Changes to This Privacy Policy</h2>
                <p>We may update this policy. Significant changes will be communicated via the app or by email.</p>

                <h2>10. Third-Party Service: Mailgun (Email Sending)</h2>
                  <p>We use <strong>Mailgun</strong> to deliver emails such as verification emails, password resets, and other kind of messages.</p>
                  <ul>
                    <li>Your email address may be processed by Mailgun</li>
                    <li>Mailgun may store email metadata (e.g., timestamps, delivery status)</li>
                    <li>Mailgun may process the content of outgoing emails</li>
                    <li>Mailgun acts as a data processor on our behalf</li>
                    <li>Mailgun does not use your data for advertising or tracking</li>
                  </ul>

                <h2>11. Third-Party Service: <a href="https://creem.io">Creem</a> (Payments and Billing)</h2>

                <p>We use <strong>Creem</strong> (operated by Armitage Labs OÜ) as our <strong>Merchant of Record</strong> to handle payments, subscriptions, billing, taxes (including VAT), refunds, and chargebacks.</p>

                <ul>
                    <li>Creem processes all payment-related transactions on our behalf</li>
                    <li>We do <strong>not</strong> collect, store, or process payment card details or other sensitive financial information</li>
                    <li>Only your <strong>email address</strong> is shared with Creem for the purpose of identifying your account and transactions</li>
                    <li>Creem may collect and process additional information in connection with payment services (such as name, billing address, and order details) as described in their privacy policy</li>
                </ul>

                <p>Creem acts as an independent data controller for the personal data it processes in connection with payments and billing. They determine the purposes and means of processing that personal data and comply with applicable data protection laws, including the GDPR. For details on how Creem handles personal data, please refer to Creem’s privacy policy at: <a href="https://www.creem.io/privacy">https://www.creem.io/privacy</a>.</p>
                <h2>12. Contact Us</h2>
                <p>If you have questions or requests regarding this policy, contact us at:<br>
                    <i class="bi bi-envelope"></i> <a href="mailto:support@justbookmark.it">support@justbookmark.it</a></p>
            </div>
        </div>
    </div>

</template>

<script>

import navbar from "@/components/NavBar";

export default {
    name: "PrivacyPolicy",
    head: {
        title: 'just bookmark it! - privacy policy'
    },
    components: {
        navbar
    }
};
</script>

<style>
    body {
        background-color: #f8f9fa;
    }
    .policy-container {
        background: #fff;
        border-radius: 0.5rem;
        padding: 2rem;
        max-width: 800px;
        margin: auto;
        box-shadow: 0 0 10px rgba(0,0,0,0.05);
    }
    h1, h2 {
     margin-top: 1.5rem;
    }
    p, li {
        font-size: 1rem;
        line-height: 1.6;
    }
</style>